'use strict';

angular.module('mean.timecards').factory('clockHours', ['$filter', 'toaster', 'Trades', '$q', 'myCoordinates', 'Hours', 'userService',
    function($filter, toaster, Trades, $q, myCoordinates, Hours, userService) {

        
        var clockIn = function(user, timestamp) {
            var deferred = $q.defer();

            myCoordinates.get().then(function(coords) {
                var hour = new Hours({
                    user: user._id,
                    date: new Date(timestamp),
                    trade_code: userService.getTradeCode(user.username),
                    company_code: userService.getCompanyCode(user.username),
                    clock_in: {
                        time: new Date(timestamp),
                        code: 'E',
                        location: {
                            lat: coords.lat,
                            lon: coords.lon
                        },
                        ip: coords.ip
                    },
                });

                hour.$save(function(success) {
                    success.user = success.user._id;
                    success.date = new Date(success.date);
                    success.clock_in.time = new Date(success.clock_in.time);

                    deferred.resolve(success);
                });
            });

            return deferred.promise;
        };

        var lunchStart = function(user, hour, timestamp) {
            var deferred = $q.defer();

            myCoordinates.get().then(function(coords) {
                hour.lunch_start = {
                    time: new Date(timestamp),
                    code: 'E',
                    location: {
                        lat: coords.lat,
                        lon: coords.lon
                    },
                    ip: coords.ip
                }

                hour.$update(function(success) {
                    success.user = success.user._id;
                    success.date = new Date(success.date);
                    success.clock_in.time = new Date(success.clock_in.time);
                    success.lunch_start.time = new Date(success.lunch_start.time);

                    deferred.resolve(success);
                })
            });

            return deferred.promise;
        };

        var lunchEnd = function(user, hour, timestamp) {
            var deferred = $q.defer();

            myCoordinates.get().then(function(coords) {
                hour.lunch_end = {
                    time: new Date(timestamp),
                    code: 'E',
                    location: {
                        lat: coords.lat,
                        lon: coords.lon
                    },
                    ip: coords.ip
                }

                hour.$update(function(success) {
                    success.user = success.user._id;
                    success.date = new Date(success.date);
                    success.clock_in.time = new Date(success.clock_in.time);
                    success.lunch_start.time = new Date(success.lunch_start.time);
                    success.lunch_end.time = new Date(success.lunch_end.time);

                    deferred.resolve(success);
                });
            });

            return deferred.promise;
        };

        var clockOut = function(user, hour, timestamp) {
            var deferred = $q.defer();

            myCoordinates.get().then(function(coords) {
                hour.clock_out = {
                    time: new Date(timestamp),
                    code: 'E',
                    location: {
                        lat: coords.lat,
                        lon: coords.lon
                    },
                    ip: coords.ip
                }

                hour.$update(function(success) {
                    success.user = success.user._id;
                    success.date = new Date(success.date);
                    success.clock_in.time = new Date(success.clock_in.time);
                    success.lunch_start.time = new Date(success.lunch_start.time);
                    success.lunch_end.time = new Date(success.lunch_end.time);
                    success.clock_out.time = new Date(success.clock_out.time);

                    deferred.resolve(success);
                });
            });

            return deferred.promise;
        };

        return {
            clockIn: clockIn,
            lunchStart: lunchStart,
            lunchEnd: lunchEnd,
            clockOut: clockOut
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/timecards/public/services/clock-hours.js